module.exports = __webpack_public_path__ + "svg/divider-pattern-red.svg";